/* global AG_FEATURES */
/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';

/**
 * Theme supports dependent imports
 * Don't forget to remove the import and the function call if a theme support is not used, this will reduce the bundle size
 */
import pageTransition from './theme-support/pageTransition';
import locomotiveScroll from './theme-support/locomotiveScroll';
import headroom from './theme-support/headroom';

/**
 * Internal dependencies
 */
import offcanvas from './util/offcanvas';
import lazyGmap from './util/lazyGmap';
import initWpBlockGalleryMagnificPopup from './util/initWpBlockGalleryMagnificPopup';
import initScroller from './util/scroller';
import initAccordion from './util/accordion';
import {
  prepare as animationPrepare,
  run as animationRun,
} from './util/animation';
import acfBlocks from './acf-blocks';
import heroHeader from './util/heroHeader';

const $body = $(document.body);

// Since barba.js maybe used if the page transition are enabled (theme support)
// we need to split the code into different parts
const handler = {
  // the code that must be only run once (initial page load)
  runOnce: () => {
    offcanvas.runOnce();


    $body.trigger('runOnce.ag.handler');
  },
  // the code that must be run everytime when the new content is ready but the page transition is still shown
  beforeRun: () => {
    offcanvas.beforeRun();
    animationPrepare();
    lazyGmap();
    initWpBlockGalleryMagnificPopup();
    initAccordion();
    initScroller();
    acfBlocks();
    heroHeader();

    const $accordion = $('.accordion, #accordion');
    if ($accordion.length) {
      $accordion.find('.card-header').on('click', e => {
        const $cardHeader = $(e.currentTarget);
        const $maybeCollapse = $cardHeader.siblings('.collapse');
        if ($maybeCollapse.length) {
          $maybeCollapse.collapse('toggle');
        }
      });

      const $collapseBtns = $accordion.find('[data-toggle=collapse]');
      const $collapse = $accordion.find('.collapse');
      $collapse.on('show.bs.collapse', e => {
        const id = $(e.target).attr('id');
        if (id) {
          $collapseBtns.filter(`[data-target="#${id}"]`).siblings('.collapse-icons').addClass('collapsed');
        }
      });

      $collapse.on('hide.bs.collapse', e => {
        const id = $(e.target).attr('id');
        if (id) {
          $collapseBtns.filter(`[data-target="#${id}"]`).siblings('.collapse-icons').removeClass('collapsed');
        }
      });
    }


    $body.trigger('beforeRun.ag.handler');
  },
  // the code that must be run everytime when the page transition is completed
  run: () => {
    animationRun();

    $body.trigger('run.ag.handler');
  },
  runAll: () => {
    handler.runOnce();
    handler.beforeRun();
    handler.run();
  },
};

$(document).ready(() => {
  if (AG_FEATURES.headroom === true) {
    headroom();
  }

  handler.runAll();

  if (AG_FEATURES.locomotiveScroll === true) {
    locomotiveScroll();
  }

  if (AG_FEATURES.pageTransition === true) {
    pageTransition(handler);
  }
});
